import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import ClearIconML from '@/components/ClearIconML/index';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { useForm, Controller } from 'react-hook-form';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import { useTheme } from '@material-ui/core';
// import dayjs from 'dayjs';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  FormHelperText,
} from '@material-ui/core';
// import { channelMapList } from '@/constants.js';
import Button from '@material-ui/core/Button';
import DateRangePickerML from '@/components/DateRangePickerML';
import { useIntl } from 'umi';
// import AutoComplateML from '@/components/AutoComplateML';
import SearchGroupStyled from './SearchGroupStyled';

const boolList = [
  { code: '1', name: '是' },
  { code: '0', name: '否' },
];

const SearchGroup = (props) => {
  //过于国际化的方法
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    levels = [],
    query,
    handleSearch,
    restClick,
    searchRef,
    // treeList,
  } = props;
  const {
    channel,
    gender,
    memberCode,
    mobile,
    name,
    level,
    hasVip,
    // manageStore: ManageStore,
    // registerStore: RegisterStore,
    signUpDateEnd,
    signUpDateStart,
  } = query;
  const theme = useTheme();
  const { handleSubmit, control, reset, setValue, watch, errors } = useForm({
    defaultValues: {
      channel,
      gender,
      memberCode,
      mobile,
      name,
      level,
      hasVip,
      date: { startDate: signUpDateStart, endDate: signUpDateEnd },
    },
  });

  // 每个输入框清除数据
  //置空输入框
  const handleClearLevel = () => {
    setValue('level', '');
    // reset('level', '');
  };
  const handleClearHasVip = () => {
    setValue('hasVip', '');
  };
  // const handleClearChannel = () => {
  //   setValue('channel', '');
  //   // reset('channel', '');
  // };
  // const watchChannel = watch('channel');
  const watchLevel = watch('level');
  const watchHasVip = watch('hasVip');
  const [memberCodeValue, setMemberCodeValue] = useState();
  const [nameValue, setNameValue] = useState();
  const [mobileValue, setMobileValue] = useState();
  //初始状态保持的时候
  useEffect(() => {
    if (memberCode) {
      setMemberCodeValue(memberCode);
    }
    if (name) {
      setNameValue(name);
    }
    if (mobile) {
      setMobileValue(mobile);
    }
  }, [memberCode, mobile, name]);
  //控制日期控件的重置
  const [isReset, setIsReset] = useState(false);
  //点击搜素
  const handleSubmitSuccess = (submitData) => {
    const manageStore = msValue?.join('/');
    const registerStore = rsValue?.join('/');
    const propsSubmitData = {
      ...submitData,
      manageStore,
      registerStore,
      signUpDateEnd: submitData.date?.endDate,
      signUpDateStart: submitData.date?.startDate,
    };
    delete propsSubmitData.date;
    handleSearch && handleSearch(propsSubmitData);
  };
  //点击重置
  const handleRestClick = () => {
    const resetSearch = {
      channel: '',
      gender: '',
      level: '',
      hasVip: '',
      memberCode: '',
      mobile: '',
      name: '',
      date: null,
    };
    setMobileValue('');
    setMemberCodeValue('');
    setNameValue('');
    reset(resetSearch);
    setIsReset(true);
    setMsValue([]);
    setRsValue([]);
    const propsResetSearch = {
      channel: '',
      gender: '',
      level: '',
      hasVip: '',
      memberCode: '',
      mobile: '',
      name: '',
      registerStore: '',
      manageStore: '',
      registerStoreName: '',
      manageStoreName: '',
      signUpDateEnd: null,
      signUpDateStart: null,
    };
    restClick && restClick(propsResetSearch);
  };
  // 状态保持时注册门店和服务门店
  // const defaultRegisterStore = useMemo(() => {
  //   let RegisterStoreArray = [];
  //   if (RegisterStore) {
  //     RegisterStoreArray = RegisterStore.split('/');
  //   }
  //   return RegisterStoreArray;
  // }, [RegisterStore]);

  // const defaultManageStore = useMemo(() => {
  //   let ManageStoreArray = [];
  //   if (ManageStore) {
  //     ManageStoreArray = ManageStore.split('/');
  //   }
  //   return ManageStoreArray;
  // }, [ManageStore]);
  //注册门店输入框
  const [rsValue, setRsValue] = useState([]);
  const [msValue, setMsValue] = useState([]);
  return (
    <SearchGroupStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <Box className="card-content">
          <Box className="left">
            <Box className="line" mb={3}>
              <Controller
                render={(rp) => (
                  <TextField
                    name="memberCode"
                    variant="standard"
                    label={formatMessage({ id: 'cm.member.n01.lbl01' })}
                    value={rp.value ?? memberCodeValue}
                    onChange={(e) => {
                      setValue('memberCode', e.target.value);
                      setMemberCodeValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setMemberCodeValue('');
                              setValue('memberCode', '');
                            }}
                            edge="end"
                          >
                            {memberCodeValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="memberCode"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />

              <Controller
                render={(rp) => (
                  <TextField
                    name="name"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    label={formatMessage({ id: 'cm.member.n01.lbl02' })}
                    defaultValue=""
                    value={rp.value ?? nameValue}
                    onChange={(e) => {
                      setValue('name', e.target.value);
                      setNameValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('name', '');
                              setNameValue('');
                            }}
                            edge="end"
                          >
                            {nameValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="name"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label={formatMessage({ id: 'cm.member.n01.lbl02' })}
                defaultValue=""
              />
              <Controller
                // as={TextField}
                render={(rp) => (
                  <TextField
                    name="mobile"
                    control={control}
                    id="basic"
                    variant="standard"
                    value={rp.value ?? mobileValue}
                    className="input"
                    label={formatMessage({ id: 'cm.member.n01.lbl03' })}
                    defaultValue=""
                    onChange={(e) => {
                      setValue('mobile', e.target.value);
                      setMobileValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('mobile', '');
                              setMobileValue('');
                            }}
                            edge="end"
                          >
                            {mobileValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="mobile"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label={formatMessage({ id: 'cm.member.n01.lbl03' })}
                defaultValue=""
              />
              <FormControl variant="standard" className="gender">
                <InputLabel>
                  {formatMessage({ id: 'cm.member.n01.lbl04' })}
                </InputLabel>
                <Controller
                  as={
                    <Select
                      className="select"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              className="clear-btn"
                              onClick={() => reset('mobile', '')}
                              edge="end"
                            >
                              <ClearIcon className="clear-icon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    >
                      {levels && levels.length > 0 ? (
                        levels.map((item) => (
                          <MenuItem
                            key={item.code}
                            value={item.code}
                            name={item.code}
                          >
                            {item.name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>暂无数据</MenuItem>
                      )}
                    </Select>
                  }
                  // label="会员等级"
                  name="level"
                  variant="standard"
                  control={control}
                  defaultValue=""
                />
                <ClearIconML
                  handleClick={handleClearLevel}
                  clearValue={watchLevel}
                ></ClearIconML>
              </FormControl>
            </Box>
            <Box className="line">
              <FormControl variant="standard">
                <Controller
                  render={(rp) => (
                    <DateRangePickerML
                      // label="注册日期"
                      startText={formatMessage({ id: 'cm.member.n01.lbl06' })}
                      endText={formatMessage({ id: 'cm.member.n01.lbl07' })}
                      defaultStartDate={
                        signUpDateStart ? signUpDateStart : null
                      }
                      defaultEndDate={signUpDateEnd ? signUpDateEnd : null}
                      rp={rp}
                      onChange={() => {
                        setIsReset(false);
                      }}
                      name="custom-form-submit-name"
                      isReset={isReset}
                    />
                  )}
                  name="date"
                  control={control}
                  // rules={{
                  //   validate: () => {
                  //     if (
                  //       (!watch('level') && !watch('name')) ||
                  //       watch('memberCode') ||
                  //       watch('mobile') ||
                  //       watch('channel') ||
                  //       rsValue?.length > 0 ||
                  //       msValue?.length > 0
                  //     ) {
                  //       return true;
                  //     }
                  //     const status = Boolean(
                  //       !getValues('date')?.startDate ||
                  //         !getValues('date')?.endDate,
                  //     );
                  //     if (status) {
                  //       return false;
                  //     }
                  //     const dateStatus = dayjs(getValues('date')?.endDate).diff(
                  //       dayjs(getValues('date')?.startDate),
                  //       'day',
                  //     );
                  //     return dateStatus < 366;
                  //   },
                  // }}
                />
                <FormHelperText error={errors?.date}>
                  {errors?.date && '日期必选且间隔不得大于一年'}
                </FormHelperText>
              </FormControl>
              <FormControl variant="standard">
                <InputLabel>
                  {/* {formatMessage({ id: 'cm.member.n01.lbl04' })} */}
                  VIP
                </InputLabel>
                <Controller
                  as={
                    <Select
                      className="select"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              className="clear-btn"
                              onClick={() => reset('mobile', '')}
                              edge="end"
                            >
                              <ClearIcon className="clear-icon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    >
                      {boolList && boolList.length > 0 ? (
                        boolList.map((item) => (
                          <MenuItem
                            key={item.code}
                            value={item.code}
                            name={item.code}
                          >
                            {item.name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>暂无数据</MenuItem>
                      )}
                    </Select>
                  }
                  // label="会员等级"
                  name="hasVip"
                  variant="standard"
                  control={control}
                  defaultValue=""
                />
                <ClearIconML
                  handleClick={handleClearHasVip}
                  clearValue={watchHasVip}
                ></ClearIconML>
              </FormControl>
              <div></div>
              <div></div>
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleRestClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'cm.member.n01.btn10' })}
            </Button>

            <Button
              data-log={JSON.stringify({
                oid: 'btn_offline_store_customer_management_list_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'cm.member.n01.btn11' })}
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
};

export default SearchGroup;
